import { faChevronRight } from "@fortawesome/sharp-solid-svg-icons";
import { Box, Stack } from "@mui/material";

import { Icon, Typography } from "../ui-v2";

export interface HelpLink {
  href: string;
  name: string;
  description: string;
  icon: React.ReactNode;
}

interface HelpLinkButtonProps {
  link: HelpLink;
}

export const HelpLinkButton = (props: HelpLinkButtonProps) => {
  const { link } = props;

  return (
    <Stack
      component="a"
      href={link.href}
      direction="row"
      spacing={6}
      sx={{
        alignItems: "center",
        padding: 6,
        border: "1px solid",
        borderColor: "secondary.6",
        borderRadius: 4,

        "&:hover": {
          backgroundColor: "secondary.7",
        },
      }}
    >
      <Box
        component="span"
        sx={{
          width: "2.5rem",
          height: "2.5rem",
          border: "1px solid",
          borderColor: "secondary.6",
          borderRadius: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {link.icon}
      </Box>
      <Stack
        direction="column"
        spacing={1}
        component="span"
        sx={{
          flexGrow: 1,
        }}
      >
        <Typography variant="regular" color="secondary.1" fontWeight={700}>
          {link.name}
        </Typography>
        <Typography variant="regular" color="secondary.2">
          {link.description}
        </Typography>
      </Stack>
      <Box
        component="span"
        sx={{
          color: "secondary.3",
        }}
      >
        <Icon icon={faChevronRight} />
      </Box>
    </Stack>
  );
};
